import Backbone from 'backbone'
import template from './template-naming-panel-contents.hbs'
import _ from 'lodash'
import $ from 'jquery'
import i18n from 'scoreboard/components/i18n'
import prefixSuffix from './prefix-suffix'
import replacePlaceholders from './replace-placeholders'

/**
 * Allows the user to specify a prefix and suffix, and shows a preview
 * of what that will look like in the application.
 */
var TemplateNamingPanelContents = Backbone.View.extend({
	// this.options:
	//  - section: the section for the panel (e.g. 'scorecards')
	//  - heading: Optional custom heading for a section panel
	//  - rollupTreeGroupLabel: a sample label to preview adding on the prefix and suffix
	//  - label: the current label for the domain object (only applies to single-org copies)
	//  - prefix: initial prefix for the label
	//  - suffix: initial suffix for the label
	//  - copyType: 'single', 'tree', or 'dataset'; used to determine if organization naming
	//    uses prefix/suffix or simple label
	//  - inputLabels: text for the labels for the inputs and the example
	//     - prefix (defaults to template.prefix)
	//     - suffix (defaults to template.suffix)
	//     - example (defaults to nothing)
	//  - placeholders: tag value substitutions to be used in the prefix and suffix preview
	//    See replace-placeholders.js for details

	className: 'template-naming-panel-contents',

	initialize: function(options) {
		this.options = options || {}
		_.defaultsDeep(this.options, {
			inputLabels: {
				prefix: i18n.get('template.prefix'),
				suffix: i18n.get('template.suffix')
			}
		})
	},

	events: {
		'keyup input': 'input'
	},

	render: function() {
		this.$el.empty().append(template(this.context()))

		var labelOnly = this._labelOnly()

		this.$('.prefix-suffix').toggleClass('is-not-displayed', labelOnly)
		this.$('.label-only').toggleClass('is-not-displayed', !labelOnly)
		process.nextTick(function() {
			// once the view is rendered, check for whether the starting text
			// should cause overflow or not
			this.checkOverflow()
		}.bind(this))

		return this
	},

	context: function() {
		let context = _.cloneDeep(this.options)
		context.styledPrefix = this.replacePlaceholders(this.options.prefix)
		context.styledSuffix = this.replacePlaceholders(this.options.suffix)

		return context
	},

	replacePlaceholders(val) {
		return replacePlaceholders(_.escape(val), this.options.placeholders)
	},

	// when the user types something, update the example text
	input: function(e) {
		var input = this.$(e.target)

		let text = this.replacePlaceholders(input.val())

		var position = input.data('position')
		this.$('.example [data-position=' + position + ']').html(text)
		this.checkOverflow()
	},

	checkOverflow: function() {
		// See if there's enough space for the example prefix/suffix text.
		// If not append .prefix-suffix-overflow to change the layout
		var textWidth = 0
		var availableSpace = (this.$('.prefix-suffix').innerWidth() / 2) - 39 // 39px padding
		this.$('.prefix, .suffix, .label').each(function(o, el) {
			// Use `.getBoundingClientRect().width` instead of `.width()` to get non-rounded widths for better accuracy
			textWidth += $(el)[0].getBoundingClientRect().width //
		})
		this.$('.prefix-suffix').toggleClass('prefix-suffix-overflow', textWidth > availableSpace)
	},

	_labelOnly: function () {
		// 'tree' and 'dataset' mode both use prefix/suffix for org naming
		return this.options.section === 'organizations'
			&& this.options.copyType === 'single'
	},

	// returns the template info (the prefix and suffix)
	info: function() {
		return {
			label: this.$('[name=label]').val(),
			prefix: this.$('[data-position=prefix]').val(),
			suffix: this.$('[data-position=suffix]').val()
		}
	},

	label: function () {
		var info = this.info()
		if (this._labelOnly()) {
			return info.label
		} else {
			return prefixSuffix.apply(
				this.options.rollupTreeGroupLabel,
				info.prefix, info.suffix
			)
		}
	}
})

export default TemplateNamingPanelContents

TemplateNamingPanelContents.__filename__ = 'templates/template-naming-panel-contents.js'
